import { getAbsoluteElementOffsetTop } from "./DOMutils";

// TODO: Extract nav element and reuse (here and every other place)
// TODO: Add utility function to get css variables, and reuse the --nav-height variable for the nav offset

const nav = document.querySelector(".js-module-nav");

export const scrollToElement = (selector, e = null, pushToHistory = true, behavior = "smooth") => {
    if (e) e.preventDefault();

    if (!selector) return;

    const element = document.querySelector(selector);
    let elementOffsetTop = 0;

    if (!element) return;

    elementOffsetTop = getAbsoluteElementOffsetTop(element);

    if (nav) elementOffsetTop -= nav.offsetHeight + 20;

    window.scrollTo({ top: elementOffsetTop, left: 0, behavior });

    if (pushToHistory) history.pushState(null, null, selector);
};

export default function() {
    document
        .querySelectorAll('a[href^="#"]')
        .forEach((link) => link.addEventListener("click", scrollToElement.bind(null, link.getAttribute("href"))));

    if (window.location.hash) {
        setTimeout(() => scrollToElement(window.location.hash), 50);
    }
}
